import {WalletTransferTab} from '#/components/wallet-transfer/wallet-transfer-tab';
import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent, createContext, useState} from 'react';

interface WalletTransferContextValue {
  tab: WalletTransferTab;
  setTab: React.Dispatch<React.SetStateAction<WalletTransferTab>>;
  completedTabs: WalletTransferTab[];
  setCompletedTabs: React.Dispatch<React.SetStateAction<WalletTransferTab[]>>;
  address: string;
  setAddress: React.Dispatch<React.SetStateAction<string>>;
}
export const WalletTransferContext = createContext<WalletTransferContextValue>({} as WalletTransferContextValue);

export const WalletTransferContextProvider: FunctionComponent<DefaultChildren> = ({children}) => {
  const [tab, setTab] = useState<WalletTransferTab>(WalletTransferTab.ACCOUNT);
  const [completedTabs, setCompletedTabs] = useState<WalletTransferTab[]>([]);

  const [address, setAddress] = useState('');

  return (
    <WalletTransferContext.Provider value={{tab, setTab, completedTabs, setCompletedTabs, address, setAddress}}>
      {children}
    </WalletTransferContext.Provider>
  );
};
